import {
  collection,
  collectionGroup,
  getDocs,
  query,
  where,
  orderBy,
  getDoc,
} from 'firebase/firestore';
import { db } from '../../../config';
import {
  DictionaryMappingType,
  DictionaryType,
  DictionaryWithMappingType,
} from '../../../../../types/dictionary';
import { masterStatus } from '../../../../../constants/enum';

// 指定辞書のマッピング一覧を取得（管理画面の展開表示用）。論理削除済み（status=99）は除外。
export const getDictionaryMappings = async (
  dictionaryId: string,
): Promise<DictionaryMappingType[]> => {
  const mappingsRef = collection(db, 'dictionaries', dictionaryId, 'dictionary_mappings');
  const q = query(mappingsRef, orderBy('created_at', 'asc'));
  const snapshot = await getDocs(q);

  return snapshot.docs
    .map(d => ({
      mapping_id: d.id,
      dictionary_id: dictionaryId,
      ...d.data(),
    }))
    .filter(
      m => (m as DictionaryMappingType).status !== masterStatus.deleted,
    ) as DictionaryMappingType[];
};

// パターン単位で、紐づく辞書本体＋マッピングをまとめて取得（OCR 結果画面・参照側用）
export const getDictionaryMappingsByPatternId = async (
  companyId: string,
  patternId: string,
): Promise<DictionaryWithMappingType[]> => {
  const mappingsRef = collectionGroup(db, 'dictionary_mappings');
  const q = query(mappingsRef, where('pattern_id', '==', patternId));
  const snapshot = await getDocs(q);

  const results: DictionaryWithMappingType[] = [];
  for (const d of snapshot.docs) {
    const dictionaryRef = d.ref.parent.parent;
    if (!dictionaryRef) continue;
    const dictionarySnap = await getDoc(dictionaryRef);
    if (!dictionarySnap.exists()) continue;
    const dictionaryData = dictionarySnap.data() as Omit<DictionaryType, 'dictionary_id'>;
    if (dictionaryData.company_id !== companyId) continue;
    // 論理削除済み（status=99）の辞書・マッピングは対象外。
    if (dictionaryData.status === masterStatus.deleted) continue;

    const mappingData = d.data() as Omit<DictionaryMappingType, 'mapping_id' | 'dictionary_id'>;
    if (mappingData.status === masterStatus.deleted) continue;
    results.push({
      dictionary_id: dictionaryRef.id,
      mapping_id: d.id,
      company_id: dictionaryData.company_id,
      file_name: dictionaryData.file_name,
      csv_columns: dictionaryData.csv_columns,
      rows: dictionaryData.rows ?? [],
      pattern_id: mappingData.pattern_id,
      pattern_name: mappingData.pattern_name,
      search_item_id: mappingData.search_item_id,
      search_item_label: mappingData.search_item_label,
      search_csv_column: mappingData.search_csv_column,
      column_mappings: mappingData.column_mappings ?? [],
      created_at: mappingData.created_at,
      updated_at: mappingData.updated_at,
    });
  }

  return results;
};
